export const state = {
  chats: [],
  newChatMessages: [],
}
